import { render, staticRenderFns } from "./KakaoChennelReg.vue?vue&type=template&id=ee8fc846"
import script from "./KakaoChennelReg.vue?vue&type=script&lang=js"
export * from "./KakaoChennelReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports